// extracted by mini-css-extract-plugin
export default {"side-footer":"sideFooter_side-footer__He0J7"};